import * as React from 'react';
import { useTheme } from '@repo/ui-web';

function resolveValue(value: string, values: Record<string, string>, depth = 0): string {
  if (depth > 4) return value;
  const match = value.match(/var\\(--([\\w-]+)\\)/);
  if (!match) return value;
  const resolved = values[match[1]];
  if (!resolved) return value;
  return resolveValue(resolved, values, depth + 1);
}

export function useCssTokens(tokens: string[]) {
  const { resolvedTheme } = useTheme();

  return React.useMemo(() => {
    if (typeof document === 'undefined') {
      return {} as Record<string, string>;
    }
    const styles = getComputedStyle(document.documentElement);
    const rawValues = tokens.reduce<Record<string, string>>((acc, token) => {
      acc[token] = styles.getPropertyValue(`--${token}`).trim();
      return acc;
    }, {});
    return tokens.reduce<Record<string, string>>((acc, token) => {
      acc[token] = resolveValue(rawValues[token], rawValues);
      return acc;
    }, {});
  }, [resolvedTheme, tokens.join('|')]);
}
